import { Category } from '@/domain/models'
import { IconName } from './icon-paths'

export type CategoryMeta = { label: string; color: string; icon: IconName }

export const CATEGORY_META: Record<Category, CategoryMeta> = {
  [Category.supermarket]: { label: 'Supermercado', color: '#16a34a', icon: 'cart' },
  [Category.home]:        { label: 'Casa',          color: '#0ea5e9', icon: 'home' },
  [Category.restaurant]:  { label: 'Restaurante',   color: '#f59e0b', icon: 'utensils' },
  [Category.transport]:   { label: 'Transporte',    color: '#6366f1', icon: 'car' },
  [Category.health]:      { label: 'Saúde',         color: '#ef4444', icon: 'heart' },
  [Category.leisure]:     { label: 'Lazer',         color: '#ec4899', icon: 'film' },
  [Category.education]:   { label: 'Educação',      color: '#8b5cf6', icon: 'book' },
  [Category.clothing]:    { label: 'Vestuário',     color: '#14b8a6', icon: 'shirt' },
  [Category.travel]:      { label: 'Viagem',        color: '#f97316', icon: 'plane' },
  [Category.electronic]:  { label: 'Eletrônicos',   color: '#64748b', icon: 'chip' },
  [Category.service]:     { label: 'Serviços',      color: '#06b6d4', icon: 'wrench' },
  [Category.investment]:  { label: 'Investimentos', color: '#84cc16', icon: 'trend' },
  [Category.other]:       { label: 'Outros',        color: '#9ca3af', icon: 'dots' },
}

export const INCOME_META: CategoryMeta = {
  label: 'Recebimento', color: '#16a34a', icon: 'wallet',
}

export const catMeta = (type: 'expense' | 'income', category: Category | null): CategoryMeta => {
  if (type === 'income' || category === null) return INCOME_META
  return CATEGORY_META[category] ?? CATEGORY_META[Category.other]
}
